export interface FiltroConsultaMatchers<T> {
  id: (item: T) => number | string | null | undefined;
  nome?: (item: T) => string | null | undefined;
  codigo?: (item: T) => string | null | undefined;
  ativo?: (item: T) => boolean | null | undefined;
}

export function aplicarFiltrosConsulta<T>(
  items: T[],
  tipoFiltro: string,
  parametro: string | null | undefined,
  situacao: boolean | null | undefined,
  matchers: FiltroConsultaMatchers<T>,
): T[] {
  let resultado = [...items];
  const termo = parametro?.trim();

  if (termo) {
    const tipo = (tipoFiltro || '').toLowerCase();
    if (tipo === 'id') {
      resultado = resultado.filter(item => String(matchers.id(item) ?? '').includes(termo));
    } else if (tipo === 'código' || tipo === 'codigo') {
      resultado = resultado.filter(item =>
        (matchers.codigo?.(item) ?? '').toLowerCase().includes(termo.toLowerCase()));
    } else {
      resultado = resultado.filter(item =>
        (matchers.nome?.(item) ?? '').toLowerCase().includes(termo.toLowerCase()));
    }
  }

  if (situacao !== null && situacao !== undefined && matchers.ativo) {
    resultado = resultado.filter(item => matchers.ativo!(item) === situacao);
  }

  return resultado;
}

export function isFiltroIdNumerico(tipoFiltro: string, parametro: string | null | undefined): number | null {
  if ((tipoFiltro || '').toLowerCase() !== 'id') {
    return null;
  }
  const termo = parametro?.trim();
  if (!termo || !/^\d+$/.test(termo)) {
    return null;
  }
  return +termo;
}

/** Classes Bootstrap padrão para campos de filtro nas telas de consulta. */
export const WOW_CONSULTA_COL_FILTRO = 'col-12 col-sm-6 col-md-4 col-lg-3';
export const WOW_CONSULTA_COL_FILTRO_WIDE = 'col-12 col-sm-6 col-lg-6';
